// extracted by mini-css-extract-plugin
export var container = "tagsInput-module--container--DdEwL";
export var input = "tagsInput-module--input--u6mmS";